import { IKnmDocumentRequest } from 'APIPackage/KnmModule/interfaces/IKnmDocumentRequest';
import { deleteObjectProperties } from 'CorePackage/MainModule/common/deleteObjectProperties';
import { IKnmFormDocument } from 'KnmPackage/KnmDocumentsModule/interfaces/IKnmFormDocument';

export const convertDocumentsFormValueToKnmData = (
  documents: (IKnmFormDocument | undefined)[] | undefined,
  isTest: boolean | undefined,
  isDraft: boolean | undefined,
) => {
  const data: IKnmDocumentRequest[] | null =
    documents?.reduce((filteredDocuments: IKnmDocumentRequest[] | null, document) => {
      let newFilteredDocuments = filteredDocuments ? [...filteredDocuments] : null;

      if ((document && document.type) || (isDraft && document?.isNew)) {
        const documentAttachments = document.attachments?.reduce(
          (filteredDocumentAttachments: IKnmDocumentRequest['attachments'] | null, documentAttachment) => {
            let newFilteredDocumentAttachments = filteredDocumentAttachments ? [...filteredDocumentAttachments] : null;

            if (isTest) {
              if (!filteredDocumentAttachments) {
                newFilteredDocumentAttachments = [];
              }
              newFilteredDocumentAttachments?.push({
                ...deleteObjectProperties(documentAttachment, ['isNew', 'listId', 'file']),
                guid: documentAttachment.guid || null,
                dateCreate: documentAttachment.dateCreate || null,
                filePath: documentAttachment.filePath || null,
                mimeType: documentAttachment.mimeType || null,
                bucketName: documentAttachment.bucketName || null,
                correlationToken: documentAttachment.correlationToken || null,
                hash: documentAttachment.hash || null,
                signed: typeof documentAttachment.signed === 'boolean' ? documentAttachment.signed : null,
              });
            } else if (
              documentAttachment.guid &&
              documentAttachment.dateCreate &&
              documentAttachment.filePath &&
              documentAttachment.mimeType &&
              documentAttachment.bucketName
            ) {
              if (!filteredDocumentAttachments) {
                newFilteredDocumentAttachments = [];
              }
              newFilteredDocumentAttachments?.push({
                ...deleteObjectProperties(documentAttachment, ['isNew', 'listId', 'file']),
                guid: documentAttachment.guid,
                dateCreate: documentAttachment.dateCreate,
                filePath: documentAttachment.filePath,
                mimeType: documentAttachment.mimeType,
                bucketName: documentAttachment.bucketName,
                correlationToken: documentAttachment.correlationToken || null,
                hash: documentAttachment.hash || null,
                signed: typeof documentAttachment.signed === 'boolean' ? documentAttachment.signed : null,
              });
            }

            return newFilteredDocumentAttachments;
          },
          null,
        );

        if (!filteredDocuments) {
          newFilteredDocuments = [];
        }
        newFilteredDocuments?.push({
          ...deleteObjectProperties(document, ['listId']),
          type: document.type ? deleteObjectProperties(document.type, ['label', 'value']) : null,
          attachments: documentAttachments,
          isNew: isDraft ? document.isNew : null,
        });
      }

      return newFilteredDocuments;
    }, null) || null;

  return data;
};
